import { render, staticRenderFns } from "./SoundVisu.vue?vue&type=template&id=e1b724a0&lang=pug&"
import script from "./SoundVisu.vue?vue&type=script&lang=js&"
export * from "./SoundVisu.vue?vue&type=script&lang=js&"
import style0 from "./SoundVisu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1b724a0')) {
      api.createRecord('e1b724a0', component.options)
    } else {
      api.reload('e1b724a0', component.options)
    }
    module.hot.accept("./SoundVisu.vue?vue&type=template&id=e1b724a0&lang=pug&", function () {
      api.rerender('e1b724a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/library/SoundVisu.vue"
export default component.exports